import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import EditScreen from './EditScreen';

import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store, intl, params }) {
    const title = intl.formatMessage(messages.addProviderOnBoardingScreens);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account && store.getState().account.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/provider-onboarding-screens', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <EditScreen id={Number(params.id)} />
            </AdminLayout>
        ),
    }
}

export default action;